// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

export const MixpanelContext = React.createContext();
